import React from 'react'

function Steps({ stepNumber, stepChanger }) {

    const handleFindStepNumber = (step) => {
        stepChanger(step)
    }

    return (
        <div className="steps">
            <ul>
                <li className={`${stepNumber === 1 ? "active" : ""}`} onClick={() => handleFindStepNumber(1)}><span>1</span> Applicant Information</li>
                <li className={`${stepNumber === 2 ? "active" : ""}`} onClick={() => handleFindStepNumber(2)}><span>2</span> Course Information</li>
                <li className={`${stepNumber === 3 ? "active" : ""}`} onClick={() => handleFindStepNumber(3)}><span>3</span> Payment</li>
            </ul>
        </div>
    )
}

export default Steps